import { routes } from '@pmai/contracts';

/** Views computed from worklogs — refreshed after a load, a re-map or a review. */
export const WORKLOG_VIEWS = [routes.worklogs.list, routes.timeOverview.get, routes.timeOverview.effective];
